import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Header from '../components/Header';
import NavbarCustom from '../components/NavbarCustom';
import TechStack from '../components/TeschStack';
import Projects from '../components/Projects';
import FooterOne from '../components/FooterOne';
import useActivePortfolio from '../configs/useActivePortfolio';
import useSeoMetadata from '../configs/useSeoMetadata';


export default function Home() {
	const { lng } = useParams();

	const { i18n } = useTranslation();
	const activePortfolio = useActivePortfolio(lng || i18n.language);

	useSeoMetadata(activePortfolio.seo);

	useEffect(() => {
		if (lng) {
			i18n.changeLanguage(lng);
		}
	}, [lng, i18n]);

	return (

		<div className="container-fluid p-0 ">
			<header>
				<NavbarCustom />
				<Header />
			</header>
			<main>
				<TechStack id="tecnologias" />
				<Projects id="proyectos" projects={activePortfolio.projects} />
				<div id="contacto"><FooterOne /></div>
			</main>

		</div>

	)

}
